"use client";

import React, { useState, useEffect } from "react";
import { Menu, X } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { NavigationMenu, NavigationMenuItem, NavigationMenuLink, NavigationMenuList } from "@/components/ui/navigation-menu";
import { Sheet, SheetContent, SheetTrigger, SheetHeader, SheetTitle } from "@/components/ui/sheet";
function NavItems({
  isMobile,
  onItemClick
}: {
  isMobile?: boolean;
  onItemClick?: () => void;
}) {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className={`flex ${isMobile ? "flex-col w-full" : "flex-row"} gap-6 p-4`}>
        {[1, 2, 3].map((_, i) => <div key={i} data-index={i} className="h-5 w-24 bg-muted/20 animate-pulse rounded-sm" />)}
      </div>;
  }
  return <NavigationMenuList className={isMobile ? "flex-col items-start w-full gap-2" : "gap-10"}>
      {menuItems.map((item, i) => <NavigationMenuItem key={item.id} data-index={i} className={isMobile ? "w-full" : ""}>
          <NavigationMenuLink asChild>
            <Link to={item.href || "#"} className={`group flex items-center gap-4 text-foreground hover:text-primary transition-all duration-300 outline-none border-none bg-transparent hover:bg-transparent ${isMobile ? "w-full py-5 border-b border-border/10" : "py-2"}`} onClick={onItemClick}>
              <span className="font-serif italic text-sm text-primary/60 group-hover:text-primary transition-colors">
                {String(i + 1).padStart(2, "0")}.
              </span>
              <span className="font-serif text-sm uppercase tracking-[0.2em] font-medium">
                {item.label}
              </span>
            </Link>
          </NavigationMenuLink>
        </NavigationMenuItem>)}
    </NavigationMenuList>;
}
export default function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  return;
}